import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	portlet: {
		boxShadow: "0px 2px 2px 0px rgba(102, 102, 102, 0.25)",
		border: `1px solid ${colors.gray[100]}`,
		height: "100%"
	},
	title: {
		fontSize: 18,
		fontWeight: 400,
		color: colors.gray[600]
	},
	contactsWithSentMessagesIcon: {
		color: colors.yellow[300],
		width: 14,
		height: 14
	},
	contactsWithResponsesReceivedIcon: {
		width: 14,
		height: 14,
		color: colors.getPrimaryColor()
	},
	contactsWithMessagesDeliveredSuccessfullyIcon: {
		color: colors.green[600],
		width: 14,
		height: 14
	},
	noExistsWhatsAppIcon: {
		width: 20,
		height: 20
	},
	healthMetricsTooltipIcons: {
		width: 18,
		height: 18,
		marginBottom: -4
	}
}))

export default useStyles
